import $ from 'jquery';
import { Component } from '../../../component';

export class Header extends Component {
    constructor(context) {
        super(context);

        this.currentScroll    = 0;
		this.$body            = $('body');
		this.$wpadminbar      = $('#wpadminbar');
		this.$header          = $('.js-site-header');
		this.$headerFloatable = $('.js-site-header__floatable');
    }

    /**
     * setup
     */
    setup() {
        // this.stick();
    }

    /**
     * scroll
     */
	raf() {
        this.stick();
    }

    /**
     * stick
     */
	stick() {
        this.$header.height(this.$headerFloatable.outerHeight());

		this.currentScroll = $(window).scrollTop();

		if ( this.currentScroll > 0 ) {
            this.$headerFloatable
                .addClass('site-header__floatable--stick')
                .addClass('site-header__floatable--floating');

			if ( $( window ).width() > 600 ) {
				if ( this.$body.hasClass( 'admin-bar' ) ) {
					this.$headerFloatable.css( { top: this.$wpadminbar.height() } );
				}
			}
			else {
				if ( this.$body.hasClass( 'admin-bar' ) ) {
					this.$headerFloatable.css( { top: 0 } );
				}
			}
		}
		else {
			this.$headerFloatable
				.removeClass( 'site-header__floatable--stick' )
				.removeClass( 'site-header__floatable--floating' );

			if ( this.$body.hasClass( 'admin-bar' ) ) {
				this.$headerFloatable.css( { top: 0 } );
			}
		}
    }
}
